import React, { useState } from "react"
import styled from "styled-components"
import L from "@/containers/MoneyFortune/View/decorate/L"

export default function StartButton({ content, onClick, hover, CanClick }) {
  const [active, setActive] = useState(false)
  const Buttonclick = () => {
    if (CanClick === true || CanClick === undefined) {
      onClick()
      setActive(true)
    }
    return
  }
  return (
    <Wrapper className={active === true && "active"} onClick={Buttonclick}>
      <Content>
        {hover ? (
          <>
            <h1 className="hoverTitle">{hover}</h1>
            <h1 className="title">{content}</h1>
          </>
        ) : (
          <h1>{content}</h1>
        )}
      </Content>

      <div className="decorate l">
        <L />
      </div>
      <div className="decorate r">
        <L />
      </div>
      <div className="decorateHover l">
        <L />
      </div>
      <div className="decorateHover r">
        <L />
      </div>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  padding: 20px 20px;
  position: relative;
  transition: 1s;
  cursor: pointer;

  h1 {
  }
  .decorate {
    width: 40px;
    height: 40px;
    position: absolute;
    transform: rotate(315deg);
    left: 0;
    transition: 0.3s;

    &.r {
      transform: rotate(135deg);
      left: auto;
      right: 0;
    }
  }
  .decorateHover {
    width: 30px;
    height: 30px;
    position: absolute;
    transform: rotate(315deg);
    left: 0px;
    transition: 0.3s;
    opacity: 0;

    &.r {
      transform: rotate(135deg);
      left: auto;
      right: 0px;
    }
  }
  @keyframes ArrowAnimate {
    0% {
      opacity: 0.3;
      scale: 1.2;
    }
    20% {
      opacity: 1;
      scale: 1;
    }
    100% {
      opacity: 0.3;
      scale: 1.2;
    }
  }

  &:hover,
  &.active {
    .decorate {
      animation: ArrowAnimate 1s infinite -0.3s;
    }
    .decorateHover {
      /* animation: ArrowAnimate 1s infinite; */
      opacity: 0.5;
      left: -30px;
      &.r {
        left: auto;
        right: -30px;
      }
    }
    h1 {
      text-shadow:
        0 0 10px #00ffeeaa,
        0 0 8px #000;
    }
    .hoverTitle {
      opacity: 1;
      transform: translate(0, 0);
      height: 60px;
      background-color: rgba(0, 255, 238, 0.203);
    }
    .title {
      opacity: 0;
      transform: translate(0, 100px);
    }
  }
  &.active {
    transform: scale(1.5);
    opacity: 0;
  }
`

const Content = styled.div`
  flex: 1 1 100%;
  position: relative;
  /* background-color: #1d1a1a; */

  h1 {
    backdrop-filter: blur(5px);
    display: flex;
    justify-content: center;
    align-items: center;
    height: 60px;
    padding: 0 30px;
    margin: 0;
    font-size: 24px;
    text-align: center;
    font-weight: 700;
    letter-spacing: 4px;
    color: #00fbfffd;
    background-color: rgba(0, 255, 238, 0.203);
    gap: 30px;
    transition: 0.3s;
    clip-path: polygon(
      30px 0,
      calc(100% - 30px) 0,
      100% 30px,
      100% calc(100% - 30px),
      calc(100% - 30px) 100%,
      30px 100%,
      0 calc(100% - 30px),
      0 30px
    );
    @media (max-width: 800px) {
      font-size: 20px;
    }
  }

  .hoverTitle {
    opacity: 0;
    position: absolute;
    top: 0;
    width: 100%;
    height: 0;
    background: rgba(0, 0, 0, 0);
    transform: translate(0, -40px);
    overflow: hidden;
    @media (max-width: 430px) {
      opacity: 1;
      transform: translate(0, 0);
      height: 60px;
      background-color: rgba(0, 255, 238, 0.203);
    }
  }
  .title {
    /* opacity: 0; */
    @media (max-width: 430px) {
      opacity: 0;
      transform: translate(0, 100px);
    }
  }
`
